import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

const SeoStore = ({ title, description }) => {
  const [storePath, setStorePath] = useState()

  const updateRoute = (event) => {
    setStorePath(event.detail)
  }

  useEffect(() => {
    window.addEventListener('storeRouteUpdated', updateRoute)
    return () => {
      window.removeEventListener('storeRouteUpdated', updateRoute)
    }
  }, [])

  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href={`https://gemvision.com${storePath}`} />
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Gemvision Store",
            "item": "https://gemvision.com/store"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default SeoStore
